import { useStyles } from './styles';

export * from './Datepicker';

export const useStylesDatepicker = useStyles;
